// Client telemetry event names (ipa-training-mode).
// Fired via services/telemetryApi.ts, which follows the same fire-and-forget
// orchestratorApiClient POST pattern used by submitFeedback/submitUndo — no new
// client subsystem, just another thin call through the existing sanctioned path.
// Orchestrator telemetry sink (relative to orchestratorApiClient's baseURL).
export const TELEMETRY_EVENTS_PATH = '/telemetry/events';
export const TELEMETRY_EVENT_COACH_SENT_IMPROVED = 'coach_sent_improved';
export const TELEMETRY_EVENT_COACH_SENT_ORIGINAL = 'coach_sent_original';
export const TELEMETRY_EVENT_COACH_EDITED = 'coach_edited';
// Distinct from COACH_SENT_ORIGINAL: the coach card was shown but the user sent
// their original draft WITHOUT ever seeing/interacting with the review (skipped
// during "analyzing" via "Send without checking"). An early habituation signal,
// not the same as a considered "I prefer my original" rejection post-review.
export const TELEMETRY_EVENT_COACH_DISMISSED_WITHOUT_ENGAGEMENT = 'coach_dismissed_without_engagement';
export const TELEMETRY_EVENT_CHIP_CLICK = 'chip_click';
export const TELEMETRY_EVENT_NUDGE_SHOWN = 'nudge_shown';
export const TELEMETRY_EVENT_NUDGE_ACCEPTED = 'nudge_accepted';
export const TELEMETRY_EVENT_NUDGE_DISMISSED = 'nudge_dismissed';
// First-enable Coach welcome (ipa-training-mode). SHOWN when the popover opens
// on first cap-on; COMPLETED via the primary "Got it" CTA; DISMISSED via close
// button / Escape / outside click. All three are fire-and-forget.
export const TELEMETRY_EVENT_COACH_WELCOME_SHOWN = 'coach_welcome_shown';
export const TELEMETRY_EVENT_COACH_WELCOME_COMPLETED = 'coach_welcome_completed';
export const TELEMETRY_EVENT_COACH_WELCOME_DISMISSED = 'coach_welcome_dismissed';
